// useCookieConsent.js
import { useState, useEffect } from 'react';

const COOKIE_PREFERENCES_KEY = 'cookiePreferences';

export const useCookieConsent = (feature) => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (stored) {
      try {
        const prefs = JSON.parse(stored);
        if (prefs && typeof prefs[feature] !== 'undefined') {
          setAllowed(prefs[feature]);
        }
      } catch (err) {
        console.error('Error parsing cookie preferences:', err);
      }
    }
  }, [feature]);

  return allowed;
};
